<template>
    <div class="lang-main">
        <h2 class="title">{{$t('多语言')}}</h2>
        <p class="menu-item-loading" v-if="translateFiled">{{translateFiled}}</p>
        <div class="menu-item" v-for="(item, i) in langList" :key="i" @click="switchLang(item.name)"
          :class="{'highlight': item.name==mainLanguage,'lang-item': activeItem == item.name }">
            <p>{{ item.text }}</p>
            <img class="status" v-if="item.status === 2" :src="require('@/assets/img/finish.png')" />
            <img class="status rolling" v-else-if="item.status === 1" :src="require('@/assets/img/loading.png')" />
            <img class="status" v-else-if="item.status === 3" :src="require('@/assets/img/mainLang.png')" />
        </div>
    </div>
</template>

<script>
export default {
    name: "lang",
    props: {
        // 接收各个语言的状态值
        langList: { // 当前组件置于哪个外部盒子内，用于定位用
            type: Array,
            default: []
        },
        activeName:{
          type:String,
          default:localStorage.getItem('mainLanguage')
        },
        translateFiled:{
          type:String,
          default:''
        },
    },

    data() {
        return {
          activeItem:this.activeName,
          mainLanguage:this.activeName,
          // 状态暂时这么设置 0为无状态 1为翻译中 2为翻译完成 3为当前语言为主语言，如果是从组件外传入，就可以不使用langList中定义的status

          // 用于适配滚动之后组件贴屏幕
          outerCoordinate: {
              left: 0,
              top: 0,
          }
        }
    },
    methods: {
        // 获取当前元素在页面的绝对定位(popMenu使用),isFixedElement针对已经在处于fixed定位上的元素使用，endElement给树的溯源增加一个元素限制
        getAbsolutePosition(element, isFixedElement = false, endElement = null) {
            let left = 0;
            let top = 0;
            let scrollTop = 0;
            let scrollLeft = 0;
            let _element = element;
            while (_element) {
                // console.log(_element, _element.offsetLeft);
                left += _element.offsetLeft;
                top += _element.offsetTop;
                if (_element === endElement) {
                    break
                }
                // 类型断言
                _element = _element.offsetParent;

            }
            _element = element;
            while (_element && !isFixedElement) {
                if (_element.scrollTop) {
                    scrollTop += _element.scrollTop;
                }
                if (_element.scrollLeft) {
                    scrollLeft += _element.scrollLeft;
                }
                if (_element === endElement) {
                    break
                }
                _element = _element.parentNode;

            }
            top = top - scrollTop;
            left = left - scrollLeft;
            return {
                left: left,
                top: top,
            }
        },

        switchLang(itemName) {
          this.activeItem = itemName
          console.log(itemName)
          this.$emit('active-name-changed', itemName);
        },

        handleScroll(e) {
            console.log(e)
        }
    },
    mounted() {
        // // 应该第一时间找到全局的主语言并设置
        // console.log(this.$parent.$refs[this.$props.outerBoxFef])
        // let parentNode = this.$parent.$refs[this.$props.outerBoxFef]
        // let coordinate = this.getAbsolutePosition(parentNode)
        // this.outerCoordinate = coordinate
        // parentNode.addEventListener('scroll', this.handleScroll)

    },
    computed: {
      // sortedLangList() {
      //   let mainLanguage = localStorage.getItem("mainLanguage")
      //   // 先找到对应 mainLanguage 的项
      //   let activeItem = this.langList.find(item => item.name === mainLanguage);
      //   // 然后找到其它的项
      //   let otherItems = this.langList.filter(item => item.name !== mainLanguage);
      //   // 如果找到了 mainLanguage，就将它放在最前面
      //   if (activeItem) {
      //     return [activeItem, ...otherItems];
      //   }
      //   // 否则，返回原始列表
      //   return this.langList;
      // }
    },
    watch: {
      activeName(newVal) {
        this.activeItem = newVal;
        this.mainLanguage = newVal;
      }
        // 'outerBox': {
        //     handler(val) {
        //         console.log(val, 'watch')
        //         if (val) {
        //         }
        //     },
        //     immediate: false
        // }
    }
}
</script>

<style scoped lang="scss">
.lang-main {
    border: 1px solid #DCDFE6;
    width: 171px;
    position: sticky;
    left: 0px;
    top: 30px;
    background-color: #fff;
    text-align: left;
    border-radius: 8px;
    box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.25);

    .title {
        font-size: 16px;
        color: #3F3F3F;
        margin-top: 8px;
        margin-bottom: 12px;
        font-weight: bold;
        padding: 0 25px;
        box-sizing: border-box;
    }
    .title:before {
      position: absolute;
      content: "";
      width: 4px;
      height: 14px;
      left: 10px;
      top: 20px;
      transform: translateY(-50%);
    }
    .title:before {
      background: #3a8ee6;
    }
  .menu-item-loading {
        box-sizing: border-box;
        padding: 2px 15px;
        font-size: 12px;
    }

    .menu-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        transition: 0.3s;
        padding: 0 20px;
        box-sizing: border-box;
        cursor: pointer;

        p {
            margin: 4px 0;
            font-size: 15px;
            color: #696666;
        }

        .status {
            width: 18px;
            height: 18px;
        }

        .rolling {
            animation: rolling 1s infinite ease-in-out;
        }

        @keyframes rolling {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    }

    .menu-item:hover {
        background-color: rgba(186,186,186,0.35);
    }

    .lang-item {
      background-color: rgba(186,186,186,0.35);
    }
    .highlight{
      font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/product/takeaway/product/part/Lang.vue